var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-only-container"},[_c('vs-checkbox',{on:{"input":_vm.Toggle},model:{value:(_vm.is_active),callback:function ($$v) {_vm.is_active=$$v},expression:"is_active"}},[_vm._v("Active Only")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }